import styled from 'styled-components';
import { ShortBody } from 'components/Typography';

interface ShortBodyType {
  lineHeight?: string;
  weight?: string;
  color?: string;
  isNewLine?: boolean;
}

export const StyledShortBody = styled(ShortBody)<ShortBodyType>`
  font-size: 13px !important;
  margin-bottom: 0px !important;
  line-height: 16px !important;
  white-space: ${({ isNewLine = true }) => (isNewLine ? 'pre-line' : 'unset')};
`;
